import type { LayoutProps } from '~/types/layout'

const ErrorLayout = ({ children }: LayoutProps) => {
  return <main className="flex h-full w-full items-center justify-center">{children}</main>
}

export default ErrorLayout
